export default __webpack_public_path__ + "static/media/navbar-brand.53aed933.svg";